function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 2,
  x: 27,
  y: 55,
  fill: "#E5A03E",
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E5A03E",
  d: "M18 53l5 5M23 53l-5 5M52.21 25.73s5.2 3.76.9 8.07c-4.3 4.31-7.79 3.92-10.86 6.99-3.07 3.07-1.5 6.37-1.5 6.37",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FDD760",
  d: "M48.924 21.38a4 4 0 015.657 5.657L34.075 47.543l-5.657-5.657L48.924 21.38zM24.883 51.078l3.535-9.192 5.657 5.657-9.192 3.535z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E5A03E",
  d: "M29.83 40.472l5.657 5.656-1.415 1.415-5.656-5.657zM46.096 24.215l5.657 5.657-1.414 1.414-5.657-5.657z"
}));

function SvgIncorporation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MHB4IiBoZWlnaHQ9IjgwcHgiPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8Zz4KICAgICAgPHJlY3Qgd2lkdGg9IjMwIiBoZWlnaHQ9IjIiIHg9IjI3IiB5PSI1NSIgZmlsbD0iI0U1QTAzRSIgcng9IjEiLz4KICAgICAgPHBhdGggc3Ryb2tlPSIjRTVBMDNFIiBzdHJva2VXaWR0aD0iMiIgZD0iTTE4IDUzbDUgNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CiAgICAgIDxwYXRoIHN0cm9rZT0iI0U1QTAzRSIgc3Ryb2tlV2lkdGg9IjIiIGQ9Ik0yMyA1M2wtNSA1IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KICAgICAgPHBhdGggc3Ryb2tlPSIjRTVBMDNFIiBzdHJva2VXaWR0aD0iMiIgZD0iTTUyLjIxIDI1LjczczUuMiAzLjc2LjkgOC4wN2MtNC4zIDQuMzEtNy43OSAzLjkyLTEwLjg2IDYuOTktMy4wNyAzLjA3LTEuNSA2LjM3LTEuNSA2LjM3IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KICAgICAgPHBhdGggZmlsbD0iI0ZERDc2MCIgZD0iTTM1LjczIDE5LjIzYTQgNCAwIDAgMSA4IDB2MjloLTh2LTI5em00IDM4bC00LTloOGwtNCA5eiIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMzkuNzMyIDM2LjIzMikiLz4KICAgICAgPHJlY3Qgd2lkdGg9IjgiIGhlaWdodD0iMiIgeD0iMjcuOTUiIHk9IjQzLjAxIiBmaWxsPSIjRTVBMDNFIiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAzMS45NTQgNDQuMDEpIi8+CiAgICAgIDxyZWN0IHdpZHRoPSI4IiBoZWlnaHQ9IjIiIHg9IjQ0LjIyIiB5PSIyNi43NSIgZmlsbD0iI0U1QTAzRSIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgNDguMjE4IDI3Ljc0NykiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgIncorporation as ReactComponent };